export default Object.freeze({
    ADMINISTRACION: 'ADMINISTRACION',
    BIENESTAR: 'BIENESTAR',
    CONTABILIDAD: 'CONTABILIDAD',
    CREATIVIDAD_INTEGRAL: 'CREATIVIDAD_INTEGRAL',
    CREDITO: 'CREDITO',
    CUMPLIMIENTO: 'CUMPLIMIENTO',
    DESARROLLO_DE_NEGOCIOS: 'DESARROLLO_DE_NEGOCIOS',
    DIRECCION: 'DIRECCION',
    FONDEO: 'FONDEO',
    JURIDICO: 'JURIDICO',
    LEAN: 'LEAN',
    SISTEMAS: 'SISTEMAS',
    MICROCREDITO_FLORESER: 'MICROCREDITO_FLORESER',
    RECUPERACION: 'RECUPERACION',
    UAIR: 'UAIR'
})
